<template>
  <v-dialog
    :key="tenant.id"
    v-model="show"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-container>
        <v-card-title
          v-if="!tenant.id"
          class="headline px-0"
        >
          {{ isEdit ? "Edit" : "New" }} Tenant
        </v-card-title>
        <v-card-text class="px-2">
          <v-form
            id="form_register_tenant"
            ref="form"
            v-model="isValid"
            lazy-validation
          >
            <v-flex>
              <!-- <strong class="form-title pb-3">Tenant Details</strong> -->
              <v-text-field
                id="tenant_name"
                ref="acc_name"
                v-model="tenant.name"
                name="account_Name"
                :rules="nameRules"
                label="Tenant Name*"
                type="text"
                autofocus
                required
                outlined
                dense
                :error-messages="getError('Name')"
                @mouseup="dirtyError('Name')"
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-if="!isEdit"
                id="register_emailId"
                v-model="tenant.emailId"
                append-icon="mdi-mail"
                name="emailId"
                label="E-mailID*"
                :rules="emailRules"
                required
                outlined
                dense
                :error-messages="getError('EmailID')"
                @mouseup="dirtyError('EmailID')"
              />
            </v-flex>
            <v-flex>
              <v-autocomplete
                v-if="!isEdit"
                id="register_country"
                v-model="tenant.countryId"
                :rules="countryRules"
                :items="countries"
                item-text="name"
                item-value="id"
                label="Country*"
                clearable
                outlined
                dense
                open-on-clear
                required
              />
            </v-flex>
            <v-flex>
              <v-autocomplete
                v-if="!isEdit"
                id="register_timeZone"
                v-model="tenant.timeZone"
                :items="timeZones"
                item-text="timeZoneType"
                item-value="timeZoneLoc"
                label="Time zone*"
                :rules="timeZoneRules"
                clearable
                outlined
                dense
                required
              />
            </v-flex>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div>
            <small style="font-weight: 400; margin-right: 4px">
              *indicates required field</small>
          </div>
          <v-spacer />
          <v-btn
            id="register_close"
            color="error"
            class="white--text"
            @click.native="close()"
          >
            Close
          </v-btn>
          <v-btn
            id="register_save"
            color="success"
            class="white--text"
            :disabled="!isValid"
            :loading="loader"
            @click.native="!isEdit ? insert() : update()"
          >
            {{ !isEdit ? "Save" : "Update" }}
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TenantRegister",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    selectedTenant: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isValid: false,
      loader: false,
      tenant: {
        name: "",
        emailId: "",
        timeZone: "",
        countryId: null
      },
      countries: [],
      timeZones: [],
      errors: {},
      nameRules: [
        (v) => !!v || "name is required",
        (v) => (v && v.length <= 25) || "name must be less than 25 characters"
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(
            v
          ) || "E-mail must be valid"
      ],
      countryRules: [(v) => !!v || "Country is required"],
      timeZoneRules: [(v) => !!v || "Time Zone is required"]
    };
  },
  computed: {
    show() {
      return this.showDialog;
    }
  },
  watch: {
    show(v) {
      if (v) {
        this.getCountries();
        this.getTimeZone();
      }
    },
    "tenant.countryId": function(newCountryId) {
      if (newCountryId) {
        const selectedCountry = this.countries.find(c => c.id === newCountryId);
        if (selectedCountry && selectedCountry.timeZoneLoc) {
          this.tenant.timeZone = selectedCountry.timeZoneLoc;
        }
      }
    }
  },
  created() {
    if (this.isEdit) {
      this.tenant.name = this.selectedTenant.name;
    }
  },

  methods: {
    close() {
      this.$emit("update:showDialog", false);
      this.$emit("refresh");
      this.clear();
    },
    insert: function () {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loader = true;
      this.$http
        .post(`${this.ADMIN_API_URL}/inventory/tenants`, this.tenant)
        .then(
          function (data) {
            this.loader = false;
            this.close();
            this.$store.commit("showSnackbar", {
              timeout: 3000,
              message: data.body.message
            });
          },
          function (failure) {
            this.loader = false;
            this.handleFailure(failure);
          }
        );
    },
    update: function () {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loader = true;
      this.$http
        .put(
          `${this.ADMIN_API_URL}/inventory/tenants/${this.selectedTenant.id}`,
          this.tenant
        )
        .then(
          function (data) {
            this.loader = false;
            this.close();
            this.$store.commit("showSnackbar", {
              timeout: 3000,
              message: data.body.message
            });
          },
          function (failure) {
            this.loader = false;
            this.handleFailure(failure);
          }
        );
    },
    getError(key) {
      return this.errors && this.errors[key] ? [this.errors[key]] : [];
    },
    dirtyError(key) {
      this.errors[key] = "";
    },
    handleFailure: function (failure) {
      let msg = failure.body.message || "Error";
      let errors = failure.body.errors;
      if (errors && errors.Name) {
        msg = errors.Name;
      }
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    },
    getCountries: function () {
      this.$http.get(`${this.ADMIN_API_URL}/countries`).then(function (data) {
        this.countries = data.body;
      });
    },
    getTimeZone: function () {
      this.$http.get(`${this.ADMIN_API_URL}/timezones`).then(
        function (data) {
          this.timeZones = data.body;
        },
        function (failure) {
          this.handleFailure(failure);
        }
      );
    },
    clear() {
      this.errors = {};
      this.$refs.form.reset();
    }
  }
};
</script>

<style>
.form-title {
  font-size: 16px;
  font-weight: 500 !important;
}
</style>
